module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.currentLayout, {
    tag: "component"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de0d9218"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-extend-layout/vue-extend-layout.vue
// module id = 434
// module chunks = 36